import 'isomorphic-fetch';

import { getAuthData } from 'authStore';

export const urlEncode = object => {
  const encodedKeyValuePairs = Object.keys(object).map(key => {
    const value = object[key];

    if(Array.isArray(value)) {
      const encodedArrayItems = value.map(item => urlEncode({[key]: item}));
      return encodedArrayItems.join('&');
    }

    return encodeKeyValue(key, value);
  });

  return encodedKeyValuePairs.join('&');
};

const encodeKeyValue = (key, value) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;

export const pageToOffsetParams = (page, pageSize) => ({offset: (page - 1) * pageSize, limit: pageSize});
export const offsetToPageParams = (offset, pageSize) => ({page: Math.floor(offset / pageSize) + 1});

export function callApi(endpoint, options = {}) {
  let finalEndpoint = endpoint;

  if(options.query) {
    finalEndpoint = `${endpoint}?${urlEncode(options.query)}`;
  }

  const fullUrl = (endpoint.indexOf('://') === -1) ?  process.env.KOOTH_API_ROOT + finalEndpoint : finalEndpoint;
  const authData = getAuthData();

  const headers = {
    'Content-Type': 'application/json',
    'Service': process.env.KOOTH_SERVICE_NAME
  };

  const finalHeaders = {
    ...headers
  };

  if (authData && authData.accessToken) {
    finalHeaders.Authorization = authData.accessToken;
  }

  const finalOptions = {
    ...options,
    headers: finalHeaders
  };

  finalOptions.body = JSON.stringify(options.body);

  return fetch(fullUrl, finalOptions)
  .then(response => {
    if(response.status !== 204) {
      return response.text()
      .then(text => {
        try {
          return { json: JSON.parse(text), response };
        }
        catch(error) {
          return { text, response };
        }
      });
    }

    return {text: '', response};
  })
  .then(({ text, json, response }) => {
    if (!response.ok) {
      const error = new Error();
      error.httpResponse = response;
      error.json = json;

      if(json) {
        error.message = json.errors.map(errorInfo => errorInfo.message).join('\n');
      }
      else {
        error.message = text;
      }

      return Promise.reject(error);
    }

    return json || text;
  });
}



/** WEBPACK FOOTER **
 ** ./src/members/state/__shared__/utils/api.js
 **/